import apiClient from '../../../Services/ApiClient';
import { Backlink } from '../../Base/Enums/Backlink.enum';

export const connectWithPatient = async (
	userId: string,
	patientId: string,
	workplaceId: string,
) => {
	const caseId = await apiClient.post(
		'/cases/doctor/' + userId + '/patient/' + patientId,
		{
			workplaceId: workplaceId,
		},
	);
	if (caseId.data.id) {
		// @ts-ignore
		window.location.href = '/ordinace/detail/' + caseId.data.id;
	}
	return caseId;
};

export const acceptCase = async (
	caseId: string,
	loggedUserId: string,
	redirect = true,
) => {
	const response = await apiClient.put(
		'/cases/' + caseId + '/assign/' + loggedUserId,
		{},
	);
	if (redirect && caseId) {
		// @ts-ignore
		window.location.href = '/ordinace/detail/' + caseId;
	}
	return response;
};

export const showCaseDetail = async (caseId: string, backlink?: Backlink) => {
	if (caseId) {
		// @ts-ignore
		window.location.href = '/ordinace/detail/' + caseId + '/' + backlink;
	}
};
